import { Grid, SxProps, Theme, Typography } from '@mui/material';
import FieldDescription from './FieldDescription';
import { ReactNode } from 'react';

interface FieldHelperTextProps {
  description?: string;
  helperText?: ReactNode;
  error?: boolean;
  sx?: SxProps<Theme>;
}

export function FieldHelperText({
  description,
  helperText,
  error,
  sx
}: FieldHelperTextProps) {
  if (!description && !helperText) return null;

  return (
    <Grid container spacing={1} sx={{ ...sx }}>
      {description && (
        <Grid item xs={helperText ? 8 : 12}>
          <FieldDescription sx={{ mb: 3, fontSize: '12px' }} description={description} />
        </Grid>
      )}
      {helperText && (
        <Grid
          item
          xs={description ? 4 : 12}
          sx={{ textAlign: 'right' }}
        >
          <Typography mb={3} fontSize={'12px'} color={error ? 'error' : 'text.secondary'}>
            {helperText}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
}